import { render, staticRenderFns } from "./StartupWidgetAvatar.vue?vue&type=template&id=5de72dbd"
import script from "./StartupWidgetAvatar.vue?vue&type=script&lang=js"
export * from "./StartupWidgetAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports